import { DietaryRequirements } from "@/clients/models/DietaryRequirements";
import { DietaryRequirementsService } from "@/clients/services/DietaryRequirementsService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation } from "@tanstack/react-query";

export const useUpdateDietaryRequirement = () => {
  const { mutate, mutateAsync, isPending, isError, error } = useMutation({
    mutationKey: [QueryKeys.DIETARY_REQUIREMENT],
    mutationFn: async (dietaryRequirement: DietaryRequirements) => {
      const user = guardGetUserFromLocalStorage();
      const { data } =
        await DietaryRequirementsService.updateDietaryRequirementsApiV1DietaryRequirementsPut(
          user.id,
          dietaryRequirement,
        );
      return data;
    },
  });

  return {
    updateDietaryRequirement: mutate,
    updateDietaryRequirementAsync: mutateAsync,
    isUpdating: isPending,
    isError,
    error,
  };
};
